import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { buddy_system, calender_img, close_icon, healthCheckMale, Shoe } from '../../../assets/images'
import { leaderBoardTeamListSchema, leaderBoardIndividualSchema } from '../../../schemas/table'
import { LeaderBoardApi } from '../../../services'
import { Breadcrumb, MetricCard } from '../../common/atoms'
import { handleAppError } from '../../handlers'
import { Tabbar, Table } from '../../common/molecules'
import {STEPATHON_LEADERBOARD as headers } from '../../../constants/tableHeaders'
import TableData from './TableData'
import { successOrFailureToaster } from '../../common/atoms/messages'
import { commaingNumber } from '../../../utils'
import { SALES_ROLE } from '../../../constants/overview'
 
 
const Leaderboard = () => {
 let location = useLocation()
 let [state , setState] = useState({ locationData : {}, metric: {}, expandArrow : null, loading : true, metricLoading : true,  TeamData : [], TeamMemberData : [], IndividualData : [], currentTab : '',  id:'' })
 let history = useHistory()
 const list = useRef([{text : 'Team'}, {text : 'Individual'}])
 const setSubState = (newState) => {
   setState(prevState => { return {...prevState, ...newState} })
 }
  let fetchMetricList = ( data) =>{
   let id = !state.locationData.id ? data?.id :  state.locationData.id
   LeaderBoardApi.fetchMetricLeaderBoard(
     { id :  id},
     (resp) => {
       let MetricData = resp.data
       setSubState({metric : MetricData, metricLoading : false})
     },
     (err) => {
       handleAppError(err);
     }
   );
 }
 
 let fetchTeamList = ( data) =>{
  let id = !state.locationData.id ? data?.id :  state.locationData.id
  LeaderBoardApi.fetchTeamListLeaderBoard(
     { id :  id},
     (resp) => {
      let TeamListData = resp.data
      setSubState({TeamData : TeamListData,  loading : false})
     },
     (err) => {
      setSubState({loading : false}) 
      handleAppError(err);
     }
   );
 } 
 
 let fetchTeamMemberList = ( team_id, term = '') =>{
   let id = state.locationData.id
   LeaderBoardApi.fetchTeamListMembersLeaderBoard(
     { id :  id, team_id : team_id, term : term},
     (resp) => {
       let TeamMemberListData = resp.data
       setSubState({TeamMemberData : TeamMemberListData})
     },
     (err) => {
       handleAppError(err);
     }
   );
 }
 let fetchIndividualMemberList = (data, term = '') =>{
  let id = !state.locationData.id ? data?.id :  state.locationData.id
  LeaderBoardApi.fetchIndividualMembersLeaderBoard(
     { id :  id, term : term},
     (resp) => {
      let IndividualData = resp.data
      setSubState({IndividualData : IndividualData, loading : false})
     },
     (err) => {
     setSubState({loading : false}) 
     handleAppError(err);
     }
   );
 }
 
 let openIndividualData = (e, team_id) => {
   if(state.expandArrow !== team_id){
    setSubState({expandArrow : team_id})
   }
   else{
    setSubState({expandArrow : null})
   }
   fetchTeamMemberList(team_id)
 }
  let onSearchHandler = (value, key) =>{
   if (key === 'team'){
     let team_id = state.expandArrow
     fetchTeamMemberList(team_id , value)
   }
   else{
      fetchIndividualMemberList( _ ,value)
   }
 
 }
 
 let getContent = () =>{
  if(state.currentTab === 'Team'){
    return (
      <Table
        headers={headers.teams}
        loading={state.loading}
        data={state.TeamData}
        openIndividualData={openIndividualData}
        IndividualData={state.TeamMemberData}
        tableClasses='alternate_gray200_color'
        classes='rounded-md mt-6 mb-4 overflow-y-auto max-h-lg'
        tableschema={leaderBoardTeamListSchema}
        tableHeaderClasses='sticky top-0 z-10'
        arrowChange={state.expandArrow}
        onSearchHandler={onSearchHandler}
      />
    )
  }
  else{
    return (
      <TableData
        individualList={true}
        loading={state.loading}
        type={state.locationData.stepathon_type}
        Classes='mt-6 mb-4'
        headers={state.locationData.stepathon_type === 'individual' ? ['EMPLOYEE NAME', 'EMPLOYEE ID', 'OVERALL STEPS TAKEN', 'EMAIL ID'] : headers.individual}
        inputClasses='bg-white' 
        key='individual'
        tableschema={leaderBoardIndividualSchema}
        IndividualData={state.IndividualData}
        onSearchHandler={onSearchHandler}
        IconHandler={onSearchHandler}
        tableClasses='mt-3 overflow-y-auto max-h-l'
        tableHeaderClasses='sticky top-0'
      />
   )
  }
 }
 useEffect(()=>{
   setSubState({locationData:  location.state, currentTab: location.state?.stepathon_type === 'individual' ? 'Individual' : 'Team'})
   fetchMetricList(location.state)
   if (location.state?.stepathon_type !== 'team'){
     fetchIndividualMemberList(location.state , '')
     list.current=[{text:'Individual'}]
     setSubState({...state , currentTab : 'Individual', locationData:  location.state})
   }
   else {
    fetchTeamList(location.state)
    setSubState({...state , currentTab : 'Team', locationData:  location.state})
   }
  },[location])
 
 
  let changeTab = (tab) =>{
   setSubState({currentTab: tab.text, loading : true})
   if(tab.text === 'Team') {
     fetchTeamList()
   }
   else {
     fetchIndividualMemberList(state.locationData,'')
   }
 }
 
 let downloadCSVData =() =>{
   let id = state.locationData.id
   let type = state.currentTab === 'Team' ? 'team' : 'member'
   state.IndividualData.length > 0 || state.TeamData.length > 0 ?
   LeaderBoardApi.downloadCSVDataLeaderboard(
      {id : id, type : type},
      (resp) => {
          var hiddenElement = document.createElement('a'); 
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(resp.data); 
          hiddenElement.target = '_blank'; 
          hiddenElement.download = state.currentTab === 'Team' ? 'Team.csv' : 'Individual.csv'
          hiddenElement.click();
          hiddenElement.remove()
          successOrFailureToaster({ message: 'Data downloaded successfully' })
        
      },
      (err) => handleAppError(err)
    )
  :
    successOrFailureToaster({ message: 'No data available to download', type: 'fail' })
}


 let {overall_step_count = 0, total_team_count = 0, start_date, end_date, member_count = 0 }  = state.metric
 let Stepathon_date = (`${moment(start_date, 'DD MMM YYYY at h:mm a').format('DD MMM')} - ${moment(end_date, 'DD MMM YYYY at h:mm a').format('DD MMM YYYY')}`)
 return (
   <div className='px-8 bg-gray-100 pt-7'>
      <div className='sticky top-0 z-0 bg-gray-100'>
        <div className='flex flex-row justify-between'>
          <div>
            <Breadcrumb list={[{ text: 'Engagement', link: '/stepathon' },{ text: 'Stepathon', link: '/stepathon' },{ text: 'Leaderboard', link : '#' },]} classes='mb-1'/>
            <p className='text-gray-800 font-semibold leading-4 text-xl'>{state.metric.stepathon_name}</p>
          </div>
          <div className='bg-white align-middle py-2.5 px-2.5 rounded-full cursor-pointer' style={{height : '32px' , width: '32px'}} onClick={() => history.push('/stepathon')}>
            <img src={close_icon} />
          </div>
        </div>
        <hr color='#E5E8F0' className='mt-6 mb-8'></hr>
      </div>
     <p className='text-gray-500 text-xs leading-3 tracking-widest font-semibold mt-8 mb-3'>STEPATHON OVERVIEW</p>
     <div className='flex flex-row justify-between'>
        <MetricCard
           title='Overall steps taken by all the teams'
           loading={state.metricLoading}
           loaderHeight={150}
           svgsrc={Shoe}
           titleClasses='text-gray-600 leading-4 block'
           metricClasses='mt-7  xl:mt-6'
           classes='w-1/3 mr-4 bg-white'
           metricValue={<span className='font-semibold text-2xl text-gray-700 leading-7'>{commaingNumber(overall_step_count)}</span>}
        />
         <MetricCard
           title={state.currentTab === 'Team' ? 'Number of teams created': 'Number of participants'}
           svgsrc={state.currentTab === 'Team' ? buddy_system : healthCheckMale}
           loading={state.metricLoading}
           loaderHeight={150}
           classes='w-1/3 mr-4 bg-white'
           titleClasses='text-gray-600 leading-4 block'
           metricValue={<span className=' font-semibold text-2xl text-gray-700 leading-7'>{state.currentTab === 'Team' ? `${commaingNumber(state.TeamData.length)} teams` : commaingNumber(state.IndividualData.length)} </span>}
        />
         <MetricCard
           title='Stepathon start and end time'
           svgsrc={calender_img}
           loading={state.metricLoading}
           loaderHeight={150}
           classes='w-1/3 bg-white'
           titleClasses='text-gray-600 leading-4 block'
           metricValue={<span className=' font-semibold  text-2xl text-gray-700 leading-7'>{Stepathon_date}</span>}
         />    
     </div>
     <div className='flex flex-row justify-between w-full sticky top-11 z-0 bg-gray-100'>
     <div
       style={{width : '88%'}}
       className='xl:w-5xl'
     >
     <Tabbar
       list= {list.current}
       classes='mt-5'
       currentPage={state.currentTab ?? 'Individual'}
       setContract={changeTab}
     />
     </div>
    <button
         type='button'
         download='download'
         onClick={downloadCSVData}
         disabled={SALES_ROLE === 'sales'}
         className={`py-2 px-4 mt-8 rounded-md bg-blue-600 text-base font-semibold text-white ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
       >
       Download CSV
     </button>
     </div>
     <div className='overflow-x-auto overflow-y-auto' style={{'minHeight': '22rem'}}>
     {getContent()}
     </div>
   </div>
 )
}
 
export default Leaderboard